import React, { useState } from 'react';
import { Container, Box, Grid, Card, CardContent, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import PaymentButton from '../PaymentButton';
import EmailCollectionModal from '../EmailCollectionModal';
import { saveEmailSignup } from '../../utils/api';

const SupportSection = ({ FadeInSection }) => {
    const navigate = useNavigate();
    const [emailModalOpen, setEmailModalOpen] = useState(false);

    const handleEmailSubmit = async (data) => {
        try {
            await saveEmailSignup(data.name, data.email, 'landing_page_support', '10%');
            alert('Dziękujemy! Otrzymasz powiadomienie o premierze pełnej wersji aplikacji wraz z 10% rabatem.');
        } catch (error) {
            console.error('Failed to save email:', error);
            throw error;
        }
    };

    return (
        <Box id="support-us" sx={{ py: 8, bgcolor: 'grey.50' }}>
            <Container maxWidth="xl">
                <FadeInSection>
                    <Typography
                        variant="h3"
                        sx={{
                            textAlign: 'center',
                            fontWeight: 'bold',
                            color: 'grey.800',
                            mb: 6
                        }}
                    >
                        Wesprzyj nas i zyskaj
                    </Typography>
                </FadeInSection>

                <Grid container spacing={4} justifyContent="center" alignItems="stretch">
                    {/* Card 1: Take Part in Study */}
                    <Grid item xs={12} sm={6} md={4} lg={3.5} sx={{ display: 'flex' }}>
                        <FadeInSection delay={0.1}>
                            <Card sx={{
                                height: '100%',
                                width: '100%',
                                p: 3,
                                textAlign: 'center',
                                display: 'flex',
                                flexDirection: 'column'
                            }}>
                                <CardContent sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    flexGrow: 1,
                                    justifyContent: 'space-between'
                                }}>
                                    <Box>
                                        <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 2, color: 'grey.800' }}>
                                            Weź udział w badaniu
                                        </Typography>
                                        <Typography variant="body2" sx={{ color: 'grey.600', mb: 3, lineHeight: 1.6 }}>
                                            Przetestuj prototyp aplikacji i pomóż nam go udoskonalić. Twoje opinie są dla nas bezcenne i pomogą stworzyć lepsze narzędzie wspierające dobrostan i motywację.
                                        </Typography>
                                    </Box>
                                    <Button
                                        fullWidth
                                        variant="outlined"
                                        onClick={() => navigate('/ankieta')}
                                        sx={{
                                            borderColor: 'primary.main',
                                            color: 'primary.main',
                                            '&:hover': {
                                                bgcolor: 'grey.100',
                                                borderColor: 'secondary.main',
                                                transform: 'scale(1.05)'
                                            },
                                            transition: 'all 0.3s ease'
                                        }}
                                    >
                                        Weź udział w badaniu
                                    </Button>
                                </CardContent>
                            </Card>
                        </FadeInSection>
                    </Grid>

                    {/* Card 2: Payment - Middle (Highlighted) */}
                    <Grid item xs={12} sm={6} md={4} lg={3.5} sx={{ display: 'flex' }}>
                        <FadeInSection delay={0.2}>
                            <Card sx={{
                                height: '100%',
                                width: '100%',
                                p: 3,
                                textAlign: 'center',
                                position: 'relative',
                                display: 'flex',
                                flexDirection: 'column'
                            }}>
                                <CardContent sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    flexGrow: 1,
                                    justifyContent: 'space-between'
                                }}>
                                    <Box>
                                        <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 1, color: 'grey.800' }}>
                                            Wpłać i bądź pierwszy
                                        </Typography>
                                        <Typography variant="h4" sx={{ fontWeight: 'bold', color: 'primary.main', mb: 2 }}>
                                            10 zł
                                        </Typography>
                                        <Typography variant="body2" sx={{ color: 'grey.600', mb: 3, lineHeight: 1.6 }}>
                                            Wykup dostęp do pełnej wersji aplikacji już dziś za jedyne 10 zł. To symboliczny wkład w rozwój projektu, który nagrodzimy dożywotnim 20% rabatem na subskrypcję po jej oficjalnym starcie.
                                        </Typography>
                                    </Box>
                                    <PaymentButton
                                        amount={1000}
                                        description="Find solution - Wczesny dostęp"
                                        buttonText="Wspieraj rozwój"
                                        onSuccess={() => {
                                            alert('Dziękujemy za wsparcie! Możesz teraz korzystać z pełnej wersji aplikacji.');
                                        }}
                                        onError={(error) => {
                                            console.error('Payment failed:', error);
                                            alert('Wystąpił błąd podczas płatności. Spróbuj ponownie.');
                                        }}
                                    />
                                </CardContent>
                            </Card>
                        </FadeInSection>
                    </Grid>

                    {/* Card 3: Email Signup */}
                    <Grid item xs={12} sm={6} md={4} lg={3.5} sx={{ display: 'flex' }}>
                        <FadeInSection delay={0.3}>
                            <Card sx={{
                                height: '100%',
                                width: '100%',
                                p: 3,
                                textAlign: 'center',
                                display: 'flex',
                                flexDirection: 'column'
                            }}>
                                <CardContent sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    flexGrow: 1,
                                    justifyContent: 'space-between'
                                }}>
                                    <Box>
                                        <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 2, color: 'grey.800' }}>
                                            Zapisz się na powiadomienie
                                        </Typography>
                                        <Typography variant="body2" sx={{ color: 'grey.600', mb: 3, lineHeight: 1.6 }}>
                                            Zapisz się, by dostać powiadomienie o pełnej wersji aplikacji i uzyskać 10% rabatu na subskrypcję. Nie przegap startu!
                                        </Typography>
                                    </Box>
                                    <Button
                                        fullWidth
                                        variant="outlined"
                                        onClick={() => setEmailModalOpen(true)}
                                        sx={{
                                            borderColor: 'primary.main',
                                            color: 'primary.main',
                                            '&:hover': {
                                                borderColor: 'secondary.main',
                                                bgcolor: 'grey.100',
                                                transform: 'scale(1.05)'
                                            },
                                            transition: 'all 0.3s ease'
                                        }}
                                    >
                                        Zapisz się
                                    </Button>
                                </CardContent>
                            </Card>
                        </FadeInSection>
                    </Grid>
                </Grid>
            </Container>

            {/* Email Collection Modal */}
            <EmailCollectionModal
                open={emailModalOpen}
                onClose={() => setEmailModalOpen(false)}
                onSubmit={handleEmailSubmit}
                title="Zapisz się na powiadomienie"
                description="Podaj swoje dane, a poinformujemy Cię o premierze pełnej wersji Find solution. Otrzymasz także 10% rabatu na subskrypcję!"
            />
        </Box>
    );
};

export default SupportSection;
